import "./CategoryDetailComponent.scss";
import CategoryDetailMenuComponent from "./components/CategoryDetailMenuComponent/CategoryDetailMenuComponent";
import CategoryDetailViewInfoComponent from "./components/CategoryDetailViewInfoComponent/CategoryDetailViewInfoComponent";
import { useQuery } from "react-query";
import { useLocation, useParams} from "react-router-dom";
import waferssServices from "../../hooks/waferssServices";

/**
 * @function CategoryDetailComponent page to view the categories and subcategories
 * @returns {JSX.Element}
*/
const CategoryDetailComponent = ({section}) => {
    const { state } = useLocation();
    const { getContenuto } = waferssServices();

    const {id} = useParams();

    const { data: categoryDetail, isLoading } = useQuery(["categoria", id], () => getContenuto(id), {
        enabled:!!(id),
        refetchOnWindowFocus: false
    });

    return (
        <div className="CategoryDetailComponent">
            <div className="row p-0 m-0">
                <div className="col-12 col-lg-3 p-0 CategoryDetailComponent__ContainerCategoryDetailMenu">
                    <CategoryDetailMenuComponent activeItem={ id } info={ categoryDetail?.data || section } isSection={ !!( section ) }></CategoryDetailMenuComponent>
                </div>
                {!isLoading ? (<div className="col-12 col-lg-9 p-0 ">
                    <CategoryDetailViewInfoComponent info={categoryDetail?.data || section} isSection={!!(section)}></CategoryDetailViewInfoComponent>
                </div>) : null}
            </div>
        </div>
    )
};

CategoryDetailComponent.propTypes = {};

CategoryDetailComponent.defaultProps = {};

export default CategoryDetailComponent;